import { IconUsers } from "@tabler/icons-react";

import { Text } from "@fragments";

import "./styles.scss";

export default function GroupHeader({ groupInfo }) {
    return (
        <div className="group-header">
            <div className="group-header__banner-wrap">
                {groupInfo.banner ? (
                    <img
                        src={groupInfo.banner}
                        className="group-header__banner"
                        alt=""
                    />
                ) : (
                    <div className="group-header__banner group-header__banner--empty" />
                )}
            </div>

            <div className="group-header__info">
                <Text.h3 contrast={9}>{groupInfo.name}</Text.h3>
                <div className="group-header__meta">
                    <Text.span contrast={4} left={<IconUsers size={13} />}>
                        {groupInfo.posts_total}{" "}
                        {groupInfo.posts_total === 1 ? "publicação" : "publicações"}
                    </Text.span>
                </div>
            </div>
        </div>
    );
}
